module.exports = __webpack_public_path__ + "static/media/icon-baby-grey.5ea9fe56.svg";